import { render } from "./CustomPopup.vue?vue&type=template&id=145a0f14&scoped=true"
import script from "./CustomPopup.vue?vue&type=script&lang=js"
export * from "./CustomPopup.vue?vue&type=script&lang=js"

import "./CustomPopup.vue?vue&type=style&index=0&id=145a0f14&lang=scss&scoped=true"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145a0f14"]])

export default __exports__